const styles = theme => ({
  signOutBtn: {
    position: 'absolute',
    bottom: '0px',
    left: '0px',
    width: '300px',
    borderRadius: '0px',
    height: '35px',
    boxShadow: '0px 0px 2px black',
    color: 'white'
  },
  root: {
    backgroundColor: 'white'
  }
});

export default styles;